
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/apps",
      function () {
        return require("private-next-pages/about/apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/apps"])
      });
    }
  